var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseIco = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.42 28.42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-close-1{fill:#ffffff;fill-rule:evenodd;padding:5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M_310_Global_Header_standard-menu_M_310_Global_Header-standard-menu-M",
    "data-name": "M_310_Global_Header/standard-menu/M_310_Global_Header-standard-menu-M"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_close_menu",
    "data-name": "icon close menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-close-1",
    d: "M14.21,11.63,25.83,0l2.59,2.58L16.79,14.21,28.42,25.83l-2.59,2.59L14.21,16.79,2.58,28.42,0,25.83,11.63,14.21,0,2.58,2.58,0Z"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close_ico.4ee72eac.svg";
export { ForwardRef as ReactComponent };